import { render, staticRenderFns } from "./RestartTooltip.vue?vue&type=template&id=b35c7328&"
import script from "./RestartTooltip.vue?vue&type=script&lang=js&"
export * from "./RestartTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b35c7328')) {
      api.createRecord('b35c7328', component.options)
    } else {
      api.reload('b35c7328', component.options)
    }
    module.hot.accept("./RestartTooltip.vue?vue&type=template&id=b35c7328&", function () {
      api.rerender('b35c7328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/configurationManager/RestartTooltip.vue"
export default component.exports